import { provideHeadless, SearchHeadlessProvider } from '@yext/search-headless-react';
import PropTypes from 'prop-types';
import React from 'react';
import GeoAccessContextProvider from '../context/geo-access-context';
import Root from './root';
import './layout.css';
import { Helmet } from 'react-helmet';
import { VERTICAL_ALL_CONTENT } from '../utils/search-utils';

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  globalPage: PropTypes.bool
};


/**
 * Component that renders the Layout wrapper
 *
 * @component Layout
 * 
 * @param {object} props
 * 
 * @prop {object} children
 * @prop {string} className
 * @prop {boolean} globalPage
 * 
 * @return {JSX}
 */
const Layout = props => {
  const { children, className, globalPage = false } = props;

  const searcher = provideHeadless({
    apiKey: process.env.YEXT_API_KEY,
    experienceKey: process.env.YEXT_EXPERIENCE_KEY,
    locale: 'en',
    verticalKey: `${VERTICAL_ALL_CONTENT}`
  });

  return (
    <GeoAccessContextProvider>
      <Helmet>
        <link rel="preload" href="/commons.css" as="style"></link>
        <script type="text/javascript" src="//js.hsforms.net/forms/shell.js" async></script>
      </Helmet>
      <SearchHeadlessProvider searcher={searcher}>
        <Root className={className} globalPage={globalPage}>
          {children}
        </Root>
      </SearchHeadlessProvider>
    </GeoAccessContextProvider>
  );
};

Layout.propTypes = propTypes;

export default Layout;
